import React, { useState, useEffect } from "react";
import { Button, Checkbox, DatePicker, Input, Select } from "antd";
import back5 from "../../../../imgs/back5.png";
import { useDispatch, useSelector } from "react-redux";
import { DeleteFilled, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import cartAni from "../../../../imgs/cartAni.gif";
import chatIcon from "../../../../imgs/chatIcon.svg";
import quotation from "../../../../imgs/quotation.svg";
import done from "../../../../imgs/done.svg";
import axios from "axios";
import dayjs from "dayjs";
import ErrorModal from "../../../Merchant/Modals/errorModal";

const EventDetails = () => {
  const SelectedVendors = useSelector((state) => state.SelectedVendors);

  const SelectedCompanyVendor = useSelector(
    (state) => state.SelectedCompanyVendor
  );

  const SelectedBranchVendor = useSelector(
    (state) => state.SelectedBranchVendor
  );

  const ProductTaxes = useSelector((state) => state.ProductTaxes);
  const companyId = SelectedCompanyVendor?.id;
  const selectedProgramBuyer = useSelector((state) => state.selectedProgram);
  const [err, setErr] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { Option } = Select;
  const PlaceOrderData = useSelector((state) => state.PlaceOrderData);
  const router = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cartData);
  const [localCart, setCart] = useState(cart);
  const [initial, setinitial] = useState(true);
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const token = useSelector((state) => state.token);
  const [selectionMethod, setSelectionMethod] = useState("");
  const [warehouse, setWarehouse] = useState("");
  const [department, setDepartment] = useState("");
  const [location, setLocation] = useState("");
  const [scheduledDate, setScheduledDate] = useState(null);
  const [type, setType] = useState(null);

  const [locationData, setLocationData] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [paymentTerms, setPaymentTerms] = useState(null);
  const [selectedPaymentTerms, setSelectedPaymentTerms] = useState(null);
  const [showDone, setShowDone] = useState(false);

  const isEmpty = Object?.keys(PlaceOrderData)?.length === 0;
  useEffect(() => {
    dispatch({ type: "QUOTATION_FLOW", num: false });
    dispatch({
      type: "PLACE_ORDER_DATA",
      num: { ...PlaceOrderData, program: selectedProgramBuyer },
    });
    if (!isEmpty) {
      setType(PlaceOrderData?.type);
      setLocation(PlaceOrderData?.mhsssfacilityId);
      setSelectedProgram(PlaceOrderData?.program);
      if (
        PlaceOrderData?.deliveryRequiredOn !== "" ||
        PlaceOrderData?.deliveryRequiredOn != null ||
        PlaceOrderData?.deliveryRequiredOn != undefined
      ) {
        setScheduledDate(true);
        setDeliveryDate(PlaceOrderData?.deliveryRequiredOn);
      }
    }
  }, []);

  //Get Listing Payment Terms
  useEffect(() => {
    // const delay = 1000;
    const delay = 0;
    const timeoutId = setTimeout(() => {
      const params = {
        sortBy: "createdAt:desc",
        buyerProgram: selectedProgramBuyer,
        vendorcompanyId: companyId,
      };

      fetchAllAccess(params);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  const fetchAllAccess = (params) => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-payment-terms/list-for-buyer`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      )
      .then((res) => {
        let wow = [];

        res?.data?.rows.map((item, index) => {
          wow.push({
            value: item?.id,
            label: item?.method,
          });
        });
        setPaymentTerms(wow);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (type === null) {
      return;
    }

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/mhsss-facility?limit=10&sortBy=createdAt:desc&type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setLocationData(res?.data?.rows);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [type]);

  const handleOptionChange = (e) => {
    // dispatch({
    //   type: "PLACE_ORDER_DATA",
    //   num: { ...PlaceOrderData, type: e.target.value },
    // });
    setType(e.target.value);
    setSelectionMethod(e.target.value);
  };

  useEffect(() => {
    setCart(cart);
  }, [cart]);
  useEffect(() => {
    if (!initial) {
      dispatch({ type: "Cart", num: localCart });
    }
  }, [localCart]);

  const CartItem = ({ item, onIncrement, onDecrement, onDelete }) => {
    return (
      <div className="flex w-full items-center rounded-xl mt-2 bg-white p-4 border-b border-gray-300 relative">
        <img
          src={item.image}
          alt={item.name}
          className="w-24 h-24 rounded-md "
        />
        <div className="ml-4 flex-grow">
          <h2 className="text-lg font-semibold">{item.name}</h2>
          <p className="text-gray-600">
            {item.price} / {item.amount}
          </p>
          <div className="flex items-center mt-2">
            <Button
              onClick={() => {
                if (item?.quantity > item?.minOrder) {
                  onDecrement(item.id);
                }
              }}
              className="bg-gray-300 text-black px-2 rounded-md"
            >
              -
            </Button>
            <span className="mx-2">{item?.quantity}</span>
            <Button
              onClick={() => onIncrement(item.id)}
              className="bg-gray-300 text-black px-2 rounded-md"
            >
              +
            </Button>
          </div>
        </div>
        <Button
          onClick={() => onDelete(item.id)}
          className="absolute top-2 right-2 text-red-600"
          icon={<DeleteFilled />}
        />
      </div>
    );
  };

  const CardItem3 = () => {
    return (
      <div className="container mx-auto p-6">
        {/* <h1 className="text-2xl font-bold text-center mb-6">Shopping Cart</h1> */}
        <div className="overflow-x-auto relative">
          <table className="min-w-full table-auto border-collapse">
            <thead>
              <tr className="border-b text-left">
                <th className="p-4">PRODUCTS</th>
                <th className="p-4">QUANTITY</th>
                <th className="p-4">DISCOUNT</th>
                <th className="p-4">TAXES</th>
                {/* <th className="p-4">REMOVE</th> */}
                <th className="p-4">DELIVERY CHARGES</th>
                <th className="p-4">TOTAL AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {localCart?.map((item) => (
                <tr key={item.id} className="border-b relative bg-white">
                  <td className="p-4 flex items-center">
                    <img
                      src={item?.image}
                      alt={item?.name}
                      className="w-20 h-20 object-cover rounded-md mr-4"
                    />
                    <div>
                      <p className="font-bold">{item?.name}</p>
                      <p className="text-sm text-gray-500">
                        {item?.type === "basePrice" ? (
                          // Show the base price if the type is 'basePrice'
                          <>
                            Price: {item?.price} / {item?.unit}
                          </>
                        ) : (
                          // If type is not 'basePrice', show a red line and fallback price
                          <>
                            <span className="line-through text-red-500">
                              Price: {item?.price} / {item?.unit}
                            </span>
                            <br />
                            Price: {item?.unitPrice} / {item?.unit}
                          </>
                        )}
                      </p>

                      {/* <p className="text-sm text-gray-500">
                        Delivery Time: {item.deliveryTime}
                      </p> */}
                      {/* <a
                        href="#"
                        className="text-blue-500 text-sm hover:underline"
                      >
                        See details
                      </a> */}
                    </div>
                  </td>
                  <td className="p-4">
                    Quantity : {item?.quantity}{" "}
                    <div className="flex items-center mt-2">
                      <Button
                        onClick={() => {
                          if (item?.quantity > item?.minOrder) {
                            handleDecrement(item?.id);
                          }
                        }}
                        className="bg-gray-300 text-black px-2 rounded-md font-bold"
                      >
                        -
                      </Button>

                      <span className="mx-2">{item?.quantity}</span>
                      <Button
                        onClick={() => handleIncrement(item?.id)}
                        className="bg-gray-300 text-black px-2 rounded-md font-bold"
                      >
                        +
                      </Button>
                    </div>
                  </td>
                  <td className="p-4">${item?.discount?.toFixed(2)}</td>
                  <td className="p-4">${item?.taxes?.toFixed(2)}</td>
                  {/* <td className="p-4">
                    <button className="text-red-500 hover:underline">
                      Remove
                    </button>
                  </td> */}
                  <td className="p-4">
                    ${item?.delivery ? item?.delivery : 0}
                  </td>
                  <td className="p-4">${item?.total ? item?.total : 0}</td>

                  {/* <Button
                    onClick={() => onDelete(item.id)}
                    className="absolute top-2 right-2 text-red-600 "
                    style={{ fontSize: "18px" }}
                    icon={<DeleteFilled style={{ fontSize: "18px" }} />}
                  /> */}
                  <div className="absolute top-2 right-2 text-red-600 border border-gray-200 px-2 py-1 rounded-md cursor-pointer ">
                    <DeleteFilled
                      style={{ fontSize: "20px" }}
                      onClick={() => handleDelete(item?.id)}
                    />
                  </div>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Function to fetch the unit price for a single product
  const fetchUnitPrice = async (invProductId, quantity, token) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order/overall-prod-items-calc-by-buyer`,
        {
          params: {
            invProductId,
            units: quantity,
            program: selectedProgramBuyer,
          },
          headers,
        }
      );

      // Extract price and other details from the response
      const price = response?.data?.invAdvancePrice?.price || 0;
      const type = response?.data?.invAdvancePrice?.type || "";
      const taxes = response?.data?.taxDetails?.totalTax || 0;
      const discounts = response?.data?.discountDetails?.totalDiscount || 0;
      const delivery = response?.data?.deliveryFee?.totalCalcDeliveryFee || 0;
      const productTaxDetails =
        response?.data?.taxDetails?.productTaxDetails || [];

      return { price, type, taxes, discounts, delivery, productTaxDetails };
    } catch (error) {
      console.error("Error fetching unit price:", invProductId, error);
      return { price: 0, type: "", productTaxDetails: [] }; // Default values
    }
  };

  // Function to fetch taxes and discounts for a single product, including unit price
  const fetchProductDetails = async (item, token) => {
    try {
      const {
        price: unitPrice,
        type,
        taxes,
        discounts,
        delivery,
        productTaxDetails,
      } = await fetchUnitPrice(item?.id, item?.quantity, token);

      // Calculate total amount for the product
      const calculateTotal = (item, priceToUse) => {
        const total =
          priceToUse * item?.quantity + taxes - discounts + delivery;
        return total > 0 ? total?.toFixed(2) : 0; // Ensure no negative totals
      };

      const total =
        item?.type === "basePrice"
          ? calculateTotal(item, unitPrice)
          : calculateTotal(item, unitPrice);

      return {
        ...item,
        unitPrice,
        taxes,
        type,
        discount: discounts,
        total,
        delivery,
        productTaxDetails,
      };
    } catch (error) {
      console.error("Error fetching product details:", item.id, error);
      return item; // Return item unchanged if there's an error
    }
  };

  // Function to update the entire cart with unit price, taxes, and discounts
  const fetchCartWithDetails = async (cartItems, token) => {
    try {
      const updatedCartItems = await Promise.all(
        cartItems?.map((item) => fetchProductDetails(item, token))
      );
      return updatedCartItems;
    } catch (error) {
      console.error("Error updating cart items with details:", error);
      return cartItems; // Return original cart if something goes wrong
    }
  };

  // React Component
  useEffect(() => {
    const updateCart = async () => {
      const updatedCart = await fetchCartWithDetails(localCart, token);
      dispatch({ type: "Cart", num: updatedCart });
      setCart(updatedCart);
      aggregateTaxes(updatedCart);
    };

    updateCart(); // Fetch data for all cart items on mount
  }, []);

  // Handle Increment
  const handleIncrement = async (id) => {
    setinitial(false);

    // Update quantity in localCart
    const updatedCart = localCart.map((item) =>
      item.id === id ? { ...item, quantity: item.quantity + 1 } : item
    );

    // Fetch updated taxes, discounts, and total price for the modified item
    const updatedItem = await fetchProductDetails(
      updatedCart.find((item) => item.id === id),
      token
    );

    // Update the cart with the new item data (with recalculated price)
    setCart(
      updatedCart.map((item) =>
        item.id === id ? { ...item, ...updatedItem } : item
      )
    );
  };

  // Handle Decrement
  const handleDecrement = async (id) => {
    setinitial(false);

    // Update quantity in localCart, ensuring it doesn't go below 1
    const updatedCart = localCart.map((item) =>
      item.id === id && item.quantity > 1
        ? { ...item, quantity: item.quantity - 1 }
        : item
    );

    // Check if the quantity was decremented (to avoid unnecessary API calls)
    const decrementedItem = updatedCart.find((item) => item.id === id);

    if (
      decrementedItem.quantity <
      localCart.find((item) => item.id === id).quantity
    ) {
      // Fetch updated taxes, discounts, and total price for the modified item
      const updatedItem = await fetchProductDetails(decrementedItem, token);

      // Update the cart with the new item data (with recalculated price)
      setCart(
        updatedCart.map((item) =>
          item.id === id ? { ...item, ...updatedItem } : item
        )
      );
    } else {
      // No API call needed if the quantity didn't change
      setCart(updatedCart);
    }
  };

  const handleDelete = (id) => {
    setinitial(false);
    setCart(localCart.filter((item) => item.id !== id));
  };

  // Calculate subtotal based on conditions
  const subtotal = localCart?.reduce((total, item) => {
    const itemPrice =
      item?.type === "basePrice" ? item?.price : item?.unitPrice || 0; // Choose price or unitPrice
    return total + itemPrice * (item?.quantity || 0); // Multiply by quantity and add to total
  }, 0);

  const totalDelivery = localCart?.reduce((total, item) => {
    return total + (item?.delivery || 0); // Add delivery charges to total, defaulting to 0 if not available
  }, 0);

  const totalDiscount = localCart?.reduce((total, item) => {
    return total + (item?.discount || 0); // Add discount to total, defaulting to 0 if not available
  }, 0);

  const totalTaxes = localCart?.reduce((total, item) => {
    return total + (item?.taxes || 0); // Add discount to total, defaulting to 0 if not available
  }, 0);

  const total = subtotal + totalDelivery + totalTaxes - totalDiscount;

  const handleApplyPromoCode = () => {
    if (promoCode === "SAP") {
      setDiscount(15);
    } else {
      setDiscount(0);
    }
  };

  const options = locationData?.map((item) => ({
    value: item?.id,
    label: item?.name,
    address: [
      item?.lot,
      item?.address,
      item?.regionNo,
      item?.regionName,
      item?.city,
      item?.ward,
    ]
      .filter(Boolean)
      .join(", "),
  }));

  const renderOption = (option) => (
    <Option key={option?.value} value={option?.value}>
      <div className="flex flex-col">
        <h1 className="font-semibold text-gray-700 text-[0.95rem]">
          {option?.label}
        </h1>
        <p className="text-sm text-gray-500 break-words whitespace-normal overflow-wrap-break-word">
          {option?.address}
        </p>
      </div>
    </Option>
  );

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/pension-programs/names-and-icons`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((data) => {
        setPrograms(data?.data);
      })
      .catch(() => {});
  }, []);

  const programoptions = programs?.map((item) => ({
    value: item?.name,
    label: item?.name,
    imageUrl: item?.icon,
  }));

  const formatProgramNames = (data) => {
    if (data === "plwd") return "PLWD";
    else if (data === "pa-medical") return "PA Medical";
    else if (data === "pa-economical") return "PA Economical";
    else
      return data
        .replace(/-/g, " ") // Replace hyphens with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter after space or hyphen
  };

  const renderProgramOption = (option) => (
    <Option key={option?.value} value={option?.value}>
      <div className="flex items-center">
        <img
          src={option?.imageUrl}
          alt={option?.label}
          style={{ width: 24, marginRight: 8 }}
        />
        <span>
          {formatProgramNames(
            option?.label === "plwd"
              ? "PLWD"
              : option?.label === "pa-medical"
              ? "PA Medical"
              : option?.label === "pa-economical"
              ? "PA Economical"
              : option?.label
          )}
        </span>
      </div>
    </Option>
  );

  //Send Quotation

  const sendQuotationsCopy = () => {
    const orderItems = localCart.map((item) => ({
      invproductId: item?.id, // Required
      actualUnits: item?.quantity, // Required
      itemCode: item?.itemCode, // Required
    }));

    if (!PlaceOrderData?.mhsssfacilityId) {
      setErr("Please select delivery address");
      setShowErrorModal(true);
      return;
    }

    // Utility to filter out null and undefined values from an object
    const cleanObject = (obj) => {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined
        )
      );
    };

    // Map over selected vendors to create the required orders structure
    console.log(SelectedVendors);
    const orders = SelectedVendors?.map((vendor) => ({
      orderItems,
      order: cleanObject({
        mhsssfacilityId: PlaceOrderData?.mhsssfacilityId, // Required
        invpaymenttermId: PlaceOrderData?.invpaymenttermId || null, // Optional
        program: PlaceOrderData?.program || "default-program", // Buyer program
        orderDiscount: PlaceOrderData?.orderDiscount || 0, // Optional
        deliveryRequiredOn: PlaceOrderData?.deliveryRequiredOn || null, // Optional
        vendorcompanyId: vendor?.vendorcompany?.id, // Required if vendorbranchId is not provided
        vendorbranchId: vendor?.vendorcompany?.branchId || null, // Optional alternative
        products: vendor?.products,
      }),
    })).filter(
      (order) =>
        order?.order?.mhsssfacilityId &&
        (order?.order?.vendorcompanyId || order?.order?.vendorbranchId) && // Ensure required vendor info
        order?.orderItems?.length > 0 // Ensure there are order items
    );

    console.log("Filtered Orders before product id:", orders);
    // return;

    const updatedOrders = orders?.map((order) => ({
      ...order,
      orderItems: order?.orderItems?.map((item) => {
        // Check if the vendorcompanyId does not match SelectedCompanyVendor
        if (order?.order?.vendorcompanyId !== SelectedCompanyVendor) {
          // Find the vendor in SelectedVendors by vendorcompanyId
          const matchingVendor = SelectedVendors?.find(
            (vendor) =>
              vendor?.vendorcompany?.id === order?.order?.vendorcompanyId
          );
          console.log("Matching Vendor:", matchingVendor);

          // If a matching vendor is found, use its productId
          return {
            ...item,
            invproductId: matchingVendor?.productId || item?.invproductId,
            // actualUnits: matchingProduct?.itemCode === item?.itemCode ? item?.actualUnits : 0,
          };
        }

        // If vendorcompanyId matches SelectedCompanyVendor, retain the original invproductId
        return {
          ...item,
          invproductId: item?.invproductId,
        };
      }),
    }));

    console.log("Updated Orders:", updatedOrders);

    if (!orders?.length) {
      setErr("No valid orders to submit");
      setShowErrorModal(true);
      return;
    }

    // Final payload with all valid orders
    const body = updatedOrders;

    console.log("Filtered Request Body:", body);

    return;

    // API call
    // axios
    //   .post(
    //     `${process.env.REACT_APP_BASE_URL}/v1/inv-order/place-quotations`,
    //     body,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     setShowDone(true); // Show success modal
    //   })
    //   .catch((err) => {
    //     setErr(err?.response?.data?.message || "Error sending quotations");
    //     setShowErrorModal(true); // Show error modal
    //   });
  };

  const sendQuotations = () => {
    const orderItems = localCart.map((item) => ({
      invproductId: item?.id, // Required
      actualUnits: item?.quantity, // Required
      itemCode: item?.itemCode, // Required
    }));

    if (!PlaceOrderData?.mhsssfacilityId) {
      setErr("Please select delivery address");
      setShowErrorModal(true);
      return;
    }

    // Utility to filter out null and undefined values from an object
    const cleanObject = (obj) => {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined
        )
      );
    };

    // Map over selected vendors to create the required orders structure
    console.log(SelectedVendors);
    const orders = SelectedVendors?.map((vendor) => ({
      orderItems: vendor?.products?.map((product) => ({
        invproductId: product?.productId, // Required
        actualUnits:
          localCart?.find((item) => item?.itemCode === product?.itemCode)
            ?.quantity || 0, // Required, fallback to 0 if no match
      })),
      order: cleanObject({
        mhsssfacilityId: PlaceOrderData?.mhsssfacilityId, // Required
        invpaymenttermId: PlaceOrderData?.invpaymenttermId || null, // Optional
        program: PlaceOrderData?.program || "default-program", // Buyer program
        orderDiscount: PlaceOrderData?.orderDiscount || 0, // Optional
        deliveryRequiredOn: PlaceOrderData?.deliveryRequiredOn || null, // Optional
        vendorcompanyId: vendor?.vendorcompany?.id, // Required if vendorbranchId is not provided
        vendorbranchId: vendor?.vendorbranch?.id || null, // Optional alternative
      }),
    })).filter(
      (order) =>
        order?.order?.mhsssfacilityId &&
        (order?.order?.vendorcompanyId || order?.order?.vendorbranchId) && // Ensure required vendor info
        order?.orderItems?.length > 0 // Ensure there are order items
    );

    console.log("Filtered Orders before product id:", orders);

    console.log("Updated Orders:", orders);

    if (!orders?.length) {
      setErr("No valid orders to submit");
      setShowErrorModal(true);
      return;
    }

    // Final payload with all valid orders
    const body = orders;

    console.log("Filtered Request Body:", body);

    // return;

    // API call
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order/place-quotations`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setShowDone(true); // Show success modal
      })
      .catch((err) => {
        setErr(err?.response?.data?.message || "Error sending quotations");
        setShowErrorModal(true); // Show error modal
      });
  };

  const aggregateTaxes = (cartItems) => {
    const taxMap = {};

    // Loop through each cart item
    cartItems?.forEach((item) => {
      item?.productTaxDetails?.forEach((tax) => {
        // Check if the tax already exists in the map
        if (taxMap[tax?.name]) {
          // Add the calculated tax to the existing amount
          taxMap[tax?.name].totalTax += parseFloat(tax?.calculatedTax || 0);
        } else {
          // Initialize the tax if it's not already in the map
          taxMap[tax?.name] = {
            totalTax: parseFloat(tax?.calculatedTax || 0),
            taxPercent: tax?.taxPercent || 0, // Default to 0 if not provided
          };
        }
      });
    });

    // Convert the tax map to an array of objects
    const aggregatedTaxesData = Object?.entries(taxMap)?.map(
      ([name, { totalTax, taxPercent }]) => ({
        name,
        totalTax: totalTax?.toFixed(2), // Round to 2 decimal places
        taxPercent: taxPercent?.toFixed(2), // Round to 2 decimal places if needed
      })
    );

    dispatch({ type: "PRODUCT_TAXES", num: aggregatedTaxesData });

    return aggregatedTaxesData;
  };

  console.log(SelectedVendors);
  return (
    <div className="bg-[#D9EFED] min-h-screen">
      <div className="flex w-full pb-[5rem] items-center justify-center bg-[#D9EFED]">
        <div className="sm:w-[95%] flex flex-col items-center ">
          {/* {localCart.length > 0 && ( */}
          <div className="p-8 mt-6 rounded-xl bg-white w-[98%] px-12">
            {SelectedVendors?.length > 0 && (
              <div className="flex sm:items-center gap-2 mt-6 justify-between sm:flex-row flex-col ">
                <h1 className="font-semibold text-[1rem] text-gray-700">
                  {SelectedVendors?.length} Selected Vendors
                </h1>
                <div className="flex gap-3 sm:flex-row justify-end sm:mt-0 mt-3">
                  <div className="">
                    <button
                      onClick={() => {
                        dispatch({ type: "QUOTATION_FLOW", num: true });
                        router("/SuperAdmin/Inventory/SelectVendor");
                      }}
                      className="text-white font-semibold text-[0.9rem] bg-primary rounded-lg py-2 px-8"
                    >
                      Add More Vendors
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5 mt-6 mb-6">
              {SelectedVendors?.map((pen) => (
                <div
                  className={`
                        text-black
                     cursor-pointer flex items-center p-4  rounded-md shadow-sm bg-gray-50 max-w-xs relative`}
                  // onClick={() => {
                  //   if (selectedEmployees.includes(user?.employeeUserId)) {
                  //     setSelectedEmployees(
                  //       selectedEmployees.filter(
                  //         (item) => item !== user?.employeeUserId
                  //       )
                  //     );
                  //   } else {
                  //     setSelectedEmployees([
                  //       ...selectedEmployees,
                  //       user?.employeeUserId,
                  //     ]);
                  //   }
                  // }}
                >
                  <div
                    className={`
                      ${"w-16 h-16 rounded-full border-4 border-primary overflow-hidden"}
                      `}
                  >
                    <img
                      src={
                        pen?.vendorcompany?.logo
                          ? pen?.vendorcompany?.logo
                          : pen?.vendorbranch
                          ? pen?.vendorbranch?.logo
                          : "data:image/png;base64,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"
                      }
                      alt="Profile"
                      className="object-cover w-full h-full"
                    />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-[0.95rem] font-semibold capitalize">
                      {pen?.vendorcompany?.name
                        ? pen?.vendorcompany?.name
                        : pen?.vendorbranch?.name
                        ? pen?.vendorbranch?.name
                        : "----"}
                    </h3>
                    {/* <p class="text-primary font-[500]">
                        {" "}
                        {pen?.vendorcompany?.vendoraddresses?.filter(
                          (addr) => addr?.isCurrent
                        )?.[0] ? (
                          <>
                            <p>
                              {pen?.vendoraddresses?.filter(
                                (addr) => addr?.isCurrent
                              )?.[0]?.regionNo || ""}
                            </p>
                          </>
                        ) : (
                          "----"
                        )}
                      </p> */}
                  </div>
                  {/* <div
                  className="absolute top-2 right-3"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <img src={pencil} alt="edit" />
               
                </div> */}
                </div>
              ))}
            </div>
            <div className="bg-[#F6F6F6] p-5  rounded-xl">
              <CardItem3 />
              {/* {localCart.map((item) => (
                  <CardItem3
                    key={item.id}
                    item={item}
                    onIncrement={handleIncrement}
                    onDecrement={handleDecrement}
                    onDelete={handleDelete}
                  />
                ))} */}
            </div>

            <div className="w-[47%]">
              <div className="mt-4">
                <h1 className="font-semibold text-[1rem]">
                  Select delivery Address
                </h1>

                <div className="my-4  w-full gap-3 rounded-md">
                  <div className="flex gap-4 mb-4 items-center justify-between text-[1rem]">
                    <div className="mb-2 flex items-center">
                      <input
                        type="radio"
                        id="warehouseOption"
                        name="selectionMethod"
                        value="warehouse"
                        className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                        checked={type === "warehouse"}
                        onChange={handleOptionChange}
                      />
                      <label
                        htmlFor="warehouseOption"
                        className="cursor-pointer text-md inline-flex items-center ml-2"
                      >
                        Warehouse
                      </label>
                    </div>
                    <div className="mb-2 flex items-center">
                      <input
                        type="radio"
                        id="departmentOption"
                        name="selectionMethod"
                        value="department"
                        className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                        checked={type === "department"}
                        onChange={handleOptionChange}
                      />
                      <label
                        htmlFor="departmentOption"
                        className="cursor-pointer text-md inline-flex items-center ml-2"
                      >
                        Department
                      </label>
                    </div>

                    <div className="mb-2 flex items-center">
                      <input
                        type="radio"
                        id="locationOption"
                        name="selectionMethod"
                        value="location"
                        className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                        checked={type === "location"}
                        onChange={handleOptionChange}
                      />
                      <label
                        htmlFor="locationOption"
                        className="cursor-pointer text-md inline-flex items-center ml-2"
                      >
                        Location
                      </label>
                    </div>
                  </div>

                  {type !== null && (
                    <Select
                      placeholder={
                        type === "warehouse"
                          ? "Select Warehouse"
                          : type === "department"
                          ? "Select Department"
                          : "Select Location"
                      }
                      className="w-[100%] woww mb-4"
                      renderOption={renderOption}
                      onChange={(value) => {
                        // Find the selected option based on the value
                        const selectedOption = options?.find(
                          (item) => item.value === value
                        );

                        // Combine the label and address into one string
                        const fullLabel = selectedOption
                          ? `${selectedOption.label} - ${selectedOption.address}`
                          : "";

                        dispatch({
                          type: "PLACE_ORDER_DATA",
                          num: {
                            ...PlaceOrderData,
                            mhsssfacilityId: value,
                            mhsssLabel: fullLabel, // Set full label including address
                          },
                        });
                        setLocation(value);
                      }}
                      value={location !== "" ? location : null}
                    >
                      {options?.map(renderOption)}
                    </Select>

                    // <Select
                    //   placeholder={
                    //     type === "warehouse"
                    //       ? "Select Warehouse"
                    //       : type === "department"
                    //       ? "Select Department"
                    //       : "Select Location"
                    //   }
                    //   // className="wow w-[100%] mb-4"
                    //   className="w-[100%] woww mb-4"
                    //   renderOption={renderOption}
                    //   onChange={(value,option) => {
                    //     dispatch({
                    //       type: "PLACE_ORDER_DATA",
                    //       num: { ...PlaceOrderData, mhsssfacilityId: value,mhsssLabel:option?.label },
                    //     });
                    //     setLocation(value);
                    //   }}
                    //   value={location !== "" ? location : null}
                    // >
                    //   {options?.map(renderOption)}
                    // </Select>
                  )}
                </div>
              </div>

              <div className="mb-3 mt-2 ">
                <h1 className="font-semibold text-[1rem] mb-1">
                  Select Program
                </h1>

                <Select
                  placeholder="Select Program"
                  className="w-[100%] woww"
                  value={selectedProgramBuyer}
                  onChange={(value) => {
                    setSelectedProgram(value);
                    dispatch({
                      type: "PLACE_ORDER_DATA",
                      num: { ...PlaceOrderData, program: value },
                    });
                  }}
                  disabled
                >
                  {programoptions?.map(renderProgramOption)}
                </Select>
              </div>
              {/* <div className="mb-3 mt-2 ">
                  <h1 className="font-semibold text-[1rem] mb-1">
                    Select Payment Terms
                  </h1>

                  <Select
                    placeholder="Select Payment Term"
                    className="w-[100%] woww"
                    value={selectedPaymentTerms}
                    onChange={(value, option) => {
                      setSelectedPaymentTerms(value);
                      dispatch({
                        type: "PLACE_ORDER_DATA",
                        num: {
                          ...PlaceOrderData,
                          invpaymenttermId: value,
                          invpaymenttermLabel: option.label, // Fix: Extract label from option
                        },
                      });
                    }}
                    options={paymentTerms}
                  />
                </div> */}
            </div>
            <div className="pt-6">
              <Checkbox
                checked={scheduledDate}
                onChange={(e) => setScheduledDate(e.target.checked)}
                className={"checkk4 "}
              >
                Specify if you need scheduled delivery or same-day delivery for
                this order.
              </Checkbox>
              <div className={`${scheduledDate ? "w-[45%] mt-3" : "hidden"}`}>
                <DatePicker
                  style={{ marginBottom: "1.2rem" }}
                  className={`${"date-class1 p-5"} `}
                  placeholder="mm/dd/yyyy"
                  onChange={(e, f) => {
                    setDeliveryDate(f);
                    dispatch({
                      type: "PLACE_ORDER_DATA",
                      num: { ...PlaceOrderData, deliveryRequiredOn: f },
                    });
                  }}
                  value={deliveryDate !== null ? dayjs(deliveryDate) : null}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                  allowClear={false}
                />
              </div>
            </div>
          </div>
          {/* )} */}

          {/* {localCart.length > 0 && ( */}
          <div className="mt-8 flex gap-5">
            <button
              onClick={() => router(-1)}
              className="bg-red-600 rounded-xl cursor-pointer pl-8 pr-8 h-[2.5rem] text-semibold text-white w-[12rem]"
            >
              Cancel
            </button>
            <button
              // onClick={() => router("/Inventory-PlaceOrder")}
              onClick={() => {
                if (!PlaceOrderData?.mhsssfacilityId) {
                  setErr("Please select delivery address");
                  setShowErrorModal(true);
                  return;
                }
                sendQuotations();
              }}
              // onClick={() => {
              //   placeOrder();
              // }}
              className="bg-primary rounded-xl cursor-pointer pl-8 pr-8 h-[2.5rem] text-semibold text-white w-[12rem]"
            >
              Request Quotation
            </button>
          </div>
          {/* )} */}

          {/* {localCart.length === 0 && (
            <div className="mt-8">
              <img src={cartAni} className="w-[30rem] h-64 rounded-md" />
              <h1 className="text-2xl font-bold text-center mt-4 text-gray-600">
                Cart Is Empty ....
              </h1>
            </div>
          )} */}
        </div>
      </div>
      {showErrorModal && <ErrorModal setShow={setShowErrorModal} err={err} />}
      <div
        className={`${
          showDone ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="rounded-xl w-[22rem] pb-6 flex items-center justify-center p-3 bg-white flex-col">
          <img
            onClick={() => setShowDone(false)}
            src={done}
            alt=""
            className="w-20 h-20"
          />
          <p className="font-bold text-lg mt-[1.5rem] text-primary capitalize">
            Quotation request sent
          </p>
          <p className="text-center mt-5 mb-5">
            Your quotation request has been successfully submitted.
          </p>
          <button
            onClick={() => {
              setShowDone(false);
              router("/SuperAdmin/InventoryDashboard");
            }}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
